<template>
  <div class="main">
    <div class="content">
      <div class="header">
        <div class="header_quality">{{supervisionTaskData.companyName}}</div>
        <div class="header_foot">
          <div class="titleBox">
            <div class="quality">
              品质指数评分完成，最新得分：
              <span class="score">{{supervisionTaskData.qualityScore + '分'}}</span>
            </div>

            <div class="titleRight">

              <!-- <div class="header_right" @click="toScoreDetails">查看详情></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="header_two"></div>
      <div class="content_view">
        <div class="content_text">
          <div class="content_text-header">
            <span>备注说明</span>
            <span>*</span>
          </div>
          <div class="content_text-center">
            <cell-group>
                <van-field
                  v-model.trim="remack"
                  rows="3"
                  autosize
                  type="textarea"
                  maxlength="100"
                  placeholder="请在这里补充备注说明"
                  show-word-limit
                />
            </cell-group>
          </div>
        </div>
        <div class="content_text">
          <upload :imgUrl="imgUrl" :fileSource='1' :fileBizType='6'></upload>
        </div>
      </div>
      <div class="content_bottom">
        <div class="content_btn" @click="saveData">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity';
    import Upload from '../../components/Upload'
    export default {
        components: {
            Upload
        },
        data () {
            return {
                imgUrl: [], // 附件上传
                enterpriseId: this.$route.query.enterpriseId, // 企业ID
                supervisionId: this.$route.query.supervisionId, // 企业监管ID
                supervisionTaskData: {},
                remack: '', // 备注
                userList: JSON.parse(localStorage.getItem('integrityInfo'))
            };
        },
        created () {
            this.handleList();
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            // 重点关注详情
            handleList () {
                //  this.enterpriseId
                api.supervisionTaskInfo({ enterpriseId: this.enterpriseId })
                    .then(res => {
                        if (res.ret === 0) {
                            this.supervisionTaskData = res.data;
                        }
                    });
            },
            // 查看详情跳至工单详情
            toScoreDetails () {
                this.$router.push({
                    path: 'workOrder',
                    query: {
                        id: this.supervisionTaskData.enterpriseId
                    }
                });
            },
            // 提交
            saveData () {
                if (this.remack === '' || this.imgUrl === '') {
                    this.remack += '.'
                    this.remack = ''
                    this.$Toast({
                        duration: 2000,
                        message: '请正确填写资料',
                        forbidClick: true
                    })
                } else {
                    let attachs = [...this.imgUrl];
                    if (attachs) {
                        attachs.map(item => { delete item.url })
                    }

                    let parm = {
                        mark: this.remack,
                        attach: JSON.stringify(attachs),
                        supervisionId: this.supervisionId // 企业监管ID
                    };
                    // if (this.userList.integrityCountyLeader === true ||　this.userList.integrityCityLeader === true) {
                    // 管理员
                    api.exitSupervisionByAdmin(parm).then(res => {
                        if (res.ret === 0) {
                            this.$router.go(-1);
                        }
                    })
                    // } else {
                    //     // 普通
                    //     api.exitSupervision(parm).then(res => {
                    //         if (res.ret === 0) {
                    //             this.$router.replace({ path: 'scoreDetails', query: { id: this.enterpriseId, name: 'uploadData' } })
                    //         }
                    //     })
                    // }
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.main {
  background: #eee;
  width: 100%;
  height: 100vh;
  .content {
    background: #fff;
    height: 100%;
    .header {
      padding: 16px 12px 0 12px;
      overflow: hidden;
        .header_quality {
          font-size: 14px;
          line-height: 24px;
          font-weight: 700;
        }
        .header_foot {

          .quality{

            .score{
              color: #36b374;
            }
          }
          .titleBox{
            margin-top: 6px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .titleLeft{

                .titleItem{
                  margin: 8px 0;
                }
            }
            .titleRight{
              .header_right{
                color: #36b374;
              }
            }
          }
        }

      .header_left {
        float: left;
        width: 75%;
        .header_left_time {
          font-size: 12px;
          line-height: 30px;
        }
        .lawEnforcement {
          line-height: 18px;
          font-size: 12px;
        }
      }
      .content_area {
        border-radius: 6px;
        border: 1px solid #eeeeee;
      }
    }
    .header_two {
      margin-top: 20px;
      background-color: #eeeeee;
      height: 5px;
      width: 100%;
    }
    .content_view {
      .content_text {
        padding: 10px 16px;
        .content_text-header {
          padding: 16px 0;
          span:nth-child(1) {
            font-size: 14px;
          }
          span:nth-child(2) {
            color: red;
          }
        }
        .content_text-center {
          width: 100%;
          textarea {
            width: 100%;
            height: 100px;
            background: #eee;
          }
        }
        .content_text-up {
          padding: 20px 0;
        }
      }
    }
    .content_bottom {
      width: 100%;
      height: 50px;
      background: #fff;
      position: fixed;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .content_btn {
        background: #36b374;
        color: #fff;
        font-size: 14px;
        height: 40px;
        width: 93%;
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}
</style>
<style >
.van-cell{
border: 1px solid #eeeeee;
}

</style>
